import { Form, Input } from 'antd';
import { AgzNewsletterType, InvoiceByEMailAddressType } from '../../../models';

type PersonalContactDataProps = {
    privateMailHasValue: boolean;
    businessMailHasValue: boolean;
    newsLetterMailType: AgzNewsletterType; 
    invoiceMailType: InvoiceByEMailAddressType;
};

export const PersonalContactData = ({ privateMailHasValue, businessMailHasValue, newsLetterMailType, invoiceMailType }: PersonalContactDataProps) => {
    const privateMailRequired = (invoiceMailType=== InvoiceByEMailAddressType.privateEmail || newsLetterMailType === AgzNewsletterType.privateEmail) || !businessMailHasValue;
    const businessMailRequired = (invoiceMailType=== InvoiceByEMailAddressType.businessEmail || newsLetterMailType === AgzNewsletterType.businessEmail) || !privateMailHasValue;
   
    return (
        <>
            <h3>Persönliche Kontaktdaten</h3>

            <Form.Item label="Berufliche Telefonnummer (z.B. Direktwahl am Hauptarbeitsort)" name="businessPhone">
                <Input />
            </Form.Item>
            <Form.Item label="Private Telefonnummer" name="privatePhone">
                <Input />
            </Form.Item>
            <Form.Item label="Mobilenummer" name="mobilePhone">
                <Input />
            </Form.Item>
            <Form.Item
                label="Private E-Mail-Adresse"
                rules={[{ required: privateMailRequired, type: 'email' }]}
                name="privateMail"
            >
                <Input />
            </Form.Item>
            <Form.Item
                label="Persönliche geschäftliche E-Mail-Adresse (z.B. HIN-Adresse oder persönliche E-Mail-Adresse am Hauptarbeitsort)"
                name="businessMail"
                rules={[{ required: businessMailRequired, type: 'email' }]}
            >
                <Input />
            </Form.Item>
        </>
    );
};
